import { useTour } from '@reactour/tour';
import { useRef, useState, useEffect } from 'react';

const InputBox = ({
	input,
	setInput,
	handleSend,
	thinkingMode,
	openFilePicker,
	fileInputRef,
	onFilesSelected,
	onDrop,
	onDragOver,
	suggestions,
	setSuggestions,
	showSuggestions,
	setShowSuggestions,
	isTypingChatIndex,
	currentChatIndex,
	askWeb, 
	setAskWeb
}) => {
	const textareaRef = useRef(null);
	const [oneLineHeight, setOneLineHeight] = useState(0);
	const [isMultiline, setIsMultiline] = useState(false);
	const [advOptionsOpen, setAdvOptionsOpen] = useState(false);

	const { currentStep } = useTour();

    useEffect(() => {
        if (currentStep >= 5) {
            // Open your advanced-options here
            setAdvOptionsOpen(true);
        }
    }, [currentStep]);
	
	// Static Farsi suggestions related to Iran’s environment and laws
	const staticSuggestions = [// قوانین و سیاست‌ها
		"قانون حفاظت و بهسازی محیط زیست در ایران چیست؟",
		"چه سازمان‌هایی مسئول نظارت بر محیط زیست ایران هستند؟",
		"مهم‌ترین قوانین مربوط به منابع طبیعی ایران کدامند؟",
		"قانون توزیع عادلانه آب در ایران چه می‌گوید؟",
		"آیا ایران معاهدات بین‌المللی زیست‌محیطی را امضا کرده است؟",
		"چه قوانینی برای جلوگیری از آلودگی هوا در ایران وجود دارد؟",
		"جریمه‌های تخریب محیط زیست در ایران چگونه تعیین می‌شوند؟",
		"نقش قوه قضاییه در اجرای قوانین محیط زیست چیست؟",
		"چگونه می‌توان تخلفات زیست‌محیطی را گزارش داد؟",
		"چه نهادی مسئول اجرای قانون حفاظت از جنگل‌ها در ایران است؟",
		"قانون ملی شدن جنگل‌ها و مراتع چه اهدافی دارد؟",
		"آیا قطع درختان بدون مجوز جرم محسوب می‌شود؟",
		"چگونه می‌توان مجوز برداشت از منابع طبیعی دریافت کرد؟",
		"قانون حفاظت و بهره‌برداری از منابع آب کشور چه می‌گوید؟",
		"کدام قانون درباره حفاظت از گونه‌های جانوری در حال انقراض است؟",
		"آیا صید غیرمجاز در ایران مجازات دارد؟",
		"مقررات مربوط به ورود و صادرات گونه‌های گیاهی چگونه است؟",
		"قانون نحوه جلوگیری از آلودگی هوا شامل چه مواردی است؟",
		"چه قوانینی برای جلوگیری از تخریب خاک در ایران وجود دارد؟",
		"وظایف سازمان محیط زیست طبق قانون چه هستند؟",
		"چه مقرراتی درباره دفع پسماندهای صنعتی وجود دارد؟",
		"آیا آلودگی صوتی در قوانین ایران جرم‌انگاری شده است؟",
		"چگونه می‌توان خسارات زیست‌محیطی را از عاملان آن مطالبه کرد؟",
		"قانون مدیریت پسماندها در ایران چه اهدافی دارد؟",
		"آیا قانون خاصی برای حفاظت از تالاب‌ها وجود دارد؟",
		"قانون توزیع عادلانه آب چه حقوقی برای کشاورزان در نظر گرفته است؟",
		"نقش مجلس شورای اسلامی در تصویب قوانین محیط زیست چیست؟",
		"چه مقرراتی برای جلوگیری از فرسایش خاک در ایران تصویب شده است؟",
		"آیا ایران قانون خاصی برای مقابله با تغییر اقلیم دارد؟",

		"با کاهش ۱۵ درصد خودروهای شخصی چه تغییری در آلودگی هوا صورت میگیرد؟",
		"در صورت اسقاط ۱۳۰۰۰ موتور دودزا آیا تغییر معنی داری در آلودگی هوای تهران رخ می دهد؟",
		"دکتر نظری می خواهد در یک طرح جدید ۲۰۰۰ اتوبوس فرسوده یورو ۲ را از رده خارج کند. این تغییر چند درصد آلودگی هوا را کاهش می دهد؟",
		"میخواهیم دو طرح پیشنهادی ارتقا هوای تهران را بررسی کنیم 1) ۱۰۰۰ خودرو یورو ۲ اسقاط کنیم 2)  ۲۵۰۰ موتورسیکلت بدون استاندارد. کدام یک بهتر است؟",
		"وارد کردن ۳۰۰۰ خودرو برقی چه تاثیری برا آلودگی CO دارد؟",
		"۲۵ درصد خودرو های دیزلی را اگر از رده خارج کنیم چه تاثیری بر انتشار آلودگی CO دارد؟",
		"میانگین aqi در تابستان ۱۴۰۳ چقدر است؟",
		"پیش‌بینی مقدار pm 2.5 در مهرماه ۱۴۰۵ چقدر است؟",
		"روند فصلی pm10 در سال ۱۴۰۶ چگونه خواهد بود؟",
		"مقدار میانگین CO اردیبهشت ۱۴۰۲ با دی ماه ۱۴۰۲ مقایسه کن",
		"روند بهار ۱۴۰۴ را با بهار ۱۴۰۳ مقایسه کن",
		"چند روز Aqi بالای ۱۰۵ در سال ۱۴۰۵ خواهیم داشت؟",

		"علت مرگ ریشا شیر باغ وحش مشهد چه بود؟",
		"ماجرای توله پلنگ روستای سررود شهرستان کلات چه بود و در نتیجه چه شد؟",
		"در راستای فرهنگ‌سازی حفاظت از غارها چه اقداماتی صورت گرفته است؟",
		"آخرین وضعیت رودخانه شور ملارد چه می‌باشد؟",
		"در مورد ریشا چه خبری داری که به من بدهی؟",
		"در مورد گورخر سمنان چه اطلاعاتی داری؟",
		"طرح محیط‌یار چیست؟ در کجا قرار است که برگزار شود؟",
		"نمایشگاه محیط زیست استان تهران",
		"کد خبر f532ebe را شرح بده.",
		"درباره صرفه جویی در مصرف آب چه اخباری داریم؟",
		"خبر اعلام شده در کد خبر 3c2f2f0 ناراحت کننده است یا خوشحال کننده؟ چرا؟",
		"در بازه اردیبهشت ۱۴۰۳ تا مهر ۱۴۰۳ چه اخبار مهمی وجود دارد؟",

		// آلودگی و پسماند
		"دلایل اصلی آلودگی هوا در تهران چیست؟",
		"چگونه می‌توان از آلودگی صوتی در شهرها کاست؟",
		"مدیریت پسماند در شهرهای ایران چگونه انجام می‌شود؟",
		"آیا تفکیک زباله از مبدا در ایران اجباری است؟",
		"راهکارهای کاهش آلودگی پلاستیکی چیست؟",
		"چگونه صنایع می‌توانند آلودگی را کاهش دهند؟",
		"اثرات آلودگی خاک در مناطق صنعتی ایران چیست؟",
		"چه فناوری‌هایی برای تصفیه فاضلاب در ایران استفاده می‌شود؟",

		"میانگین ماهانه آلاینده PM2.5 را طی سال های ۱۴۰۰ تا ۱۴۰۴ محاسبه کن و ماه های مشابه را بین سال ها مقایسه کن.",
		"کدام آلاینده بیشترین تغییر در الگوی فصلی را طی سال های مختلف تجربه کرده است؟",
		"کدام آلاینده بیشترین همبستگی را با AQI دارد؟",
		"کدام ایستگاه بیشترین تفاوت را با میانگین شهر نشان می دهد؟",
		"در روزهای ناسالم، کدام آلاینده بیشترین سهم را در افزایش AQI داشته است؟",
		"کدام فصل بیشترین حساسیت را نسبت به افزایش PM2.5 نشان می دهد؟",
		"در سال ۱۴۰۳ برای هر استان چند رکورد کیفیت هوا ثبت شده است؟ مختصات تقریبی استان را نیز نشان بده.",
		"میانگین شاخص کیفیت هوا در ایستگاه‌های استان تهران چگونه توزیع شده است؟",
		"میانگین AQI ایستگاه های تهران در فروردین ۱۴۰۳ چقدر بوده است؟ مختصات ایستگاه ها را نیز نشان بده.",
		"کدام یک از ماه‌های سال بیشترین فراوانی روزهای بسیار ناسالم را دارند؟",
		"در چه ساعاتی از شبانه‌روز، شرایط بسیار ناسالم بیشتر مشاهده می‌شود؟",
		"سهم آلاینده‌های غالب در مشاهدات ناسالم طی سال‌های مختلف چگونه تغییر کرده است؟",

		// آموزش و آگاهی
		"چگونه می‌توان آگاهی مردم درباره محیط زیست را افزایش داد؟",
		"نقش آموزش در مدارس در حفاظت از محیط زیست چیست؟",
		"چگونه رسانه‌ها می‌توانند فرهنگ زیست‌محیطی را گسترش دهند؟",
		"چه برنامه‌هایی برای آموزش محیط زیست در ایران اجرا می‌شود؟",
		"چگونه می‌توان کودکان را با مفاهیم زیست‌محیطی آشنا کرد؟",

		// جوامع محلی و مشارکت عمومی
		"نقش جوامع محلی در حفاظت از منابع طبیعی چیست؟",
		"چگونه مردم می‌توانند در پروژه‌های محیط زیستی مشارکت کنند؟",
		"چه سازمان‌های مردم‌نهادی در ایران در حوزه محیط زیست فعال هستند؟",
		"چگونه می‌توان داوطلبانه در طرح‌های محیط زیستی شرکت کرد؟",
		"نقش زنان در مدیریت منابع طبیعی چیست؟",
		"چگونه گردشگری پایدار می‌تواند به حفاظت از طبیعت کمک کند؟",

		// دیگر پرسش‌های عمومی
		"چگونه می‌توان ردپای کربنی خود را کاهش داد؟",
		"چرا حفظ تنوع زیستی برای آینده ایران مهم است؟",
		"نقش فناوری در پایش محیط زیست چیست؟",
		"چه اقداماتی برای مقابله با ریزگردها انجام می‌شود؟",
		"آیا استفاده از خودروهای برقی در ایران رایج شده است؟",
		"چگونه می‌توان زندگی روزمره‌ای سازگار با محیط زیست داشت؟"
	];


	useEffect(() => {
		if (textareaRef.current) {
			const styles = window.getComputedStyle(textareaRef.current);
			const paddingTop = parseFloat(styles.paddingTop);
			const paddingBottom = parseFloat(styles.paddingBottom);
			const lineHeight = parseFloat(styles.lineHeight);
			const calculatedHeight = lineHeight + paddingTop + paddingBottom;
			setOneLineHeight(calculatedHeight);
		}
	}, []);


	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				advOptionsOpen &&
				!event.target.closest('.more-options')
			) {
				setAdvOptionsOpen(false);
			}
			//  hide suggestions if clicked outside
			if (!event.target.closest('.input-box')) {
				setShowSuggestions(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [advOptionsOpen, setShowSuggestions]);

	// Handle typing and suggestion filtering
	const handleChange = (e) => {
		const value = e.target.value;
		setInput(value);

		const textarea = textareaRef.current;
		if (textarea) {
			textarea.style.height = "auto";
			const newHeight = Math.min(textarea.scrollHeight, 200);
			textarea.style.height = `${newHeight}px`;
			if (!isMultiline && newHeight > oneLineHeight) {
				setIsMultiline(true);
			} else if (e.target.value === "") {
				setIsMultiline(false);
			}
		}

		// Filter suggestions based on input
		if (value.trim().length > 0) {
			const filtered = staticSuggestions.filter(s =>
				s.toLowerCase().includes(value.toLowerCase())
			);
			setSuggestions(filtered.slice(0, 5)); // show top 5
			setShowSuggestions(filtered.length > 0);
		} else {
			setShowSuggestions(false);
		}
	};

	// Handle suggestion click
	const handleSuggestionClick = (suggestion) => {
		setInput(suggestion);
		setShowSuggestions(false);
		textareaRef.current.focus();
	};

	return (
		<div
			className={`input-box ${isMultiline ? "multiline" : ""}`}
			onDrop={onDrop}
			onDragOver={onDragOver}
			dir="rtl"
			style={{ position: "relative" }} // ensure dropdown is positioned correctly
		>
			<div className="more-options">
				<button
					type="button"
					className="attach-btn"
					onClick={() => {setAdvOptionsOpen(true);}}
					title="پیوست فایل"
				>					
					<svg width="24" height="24" viewBox="0 0 640 640" fill="#014A3F" xmlns="http://www.w3.org/2000/svg">
						<path d="M352 128C352 110.3 337.7 96 320 96C302.3 96 288 110.3 288 128L288 288L128 288C110.3 288 96 302.3 96 320C96 337.7 110.3 352 128 352L288 352L288 512C288 529.7 302.3 544 320 544C337.7 544 352 529.7 352 512L352 352L512 352C529.7 352 544 337.7 544 320C544 302.3 529.7 288 512 288L352 288L352 128z"/>
					</svg>
					{/* <img src={linkIcon} alt="پیوست" style={{width: "28px"}} /> */}
				</button>
				<div className='advanced-options' style={{ display: advOptionsOpen ? 'flex' : 'none' }}>
					<button
						type="button"
						className={`thinking-btn`}
						onClick={() => { setAdvOptionsOpen(false); openFilePicker(); }}
						title="الصاق فایل"
					>
						{/* /* <img src={bulbIcon} alt="" style={{width: "26px"}} /> => This one was commented */}
						<span>الصاق فایل</span>
					</button>
					{/* <button
						type="button"
						className={`thinking-btn ${thinkingMode ? 'active' : ''}`}
						onClick={() => { setAdvOptionsOpen(false); setThinkingMode(prev => !prev) }}
						title="تفکر عمیق"
					>
						<svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M10.3398 16.1523C10.3398 16.3555 10.2656 16.543 10.1367 16.6836H3.23046C2.77343 16.1914 3.15234 15.332 3.83203 15.3477H9.53515C9.98046 15.3477 10.3398 15.707 10.3398 16.1523ZM3.23046 17.2266C2.77343 17.7188 3.15234 18.5781 3.83203 18.5625H9.53515C10.2148 18.5781 10.5937 17.7148 10.1328 17.2266H3.23046ZM5.5 19.9609H7.87109C8.3789 19.9609 8.79687 19.5898 8.8789 19.1055H4.49218C4.57421 19.5898 4.99218 19.9609 5.5 19.9609ZM10.6289 11.9609C9.79297 12.6875 9.28125 13.7109 9.17578 14.8047H7.44531V3.86719C7.44531 3.63672 7.64062 3.45312 7.87109 3.47266C12.1445 3.85156 13.8125 9.21484 10.6289 11.9609ZM11.3867 8.30469C11.3984 6.66406 10.3203 5.125 8.76562 4.58984C8.60547 4.53125 8.42187 4.61719 8.36718 4.78125C8.30859 4.94531 8.39062 5.12109 8.55468 5.17969C9.85937 5.62891 10.7695 6.92188 10.7578 8.30469C10.7656 8.71484 11.3828 8.71484 11.3867 8.30469ZM3.4375 12.9453C3.64062 12.7344 4.10156 12.4609 4.27343 12.8477C4.33593 13.0078 4.2539 13.1914 4.08984 13.2539C3.38671 13.5742 3.75 14.5234 4.1875 14.8047H5.58984C5.89062 14.5859 6.08593 14.2344 6.08593 13.8359V4.98047C6.07812 3.70312 4.32812 3.32812 3.80468 4.48828C4.22656 4.57031 5.47265 5.63281 4.57812 5.83203C4.28125 5.82031 4.21484 5.42578 3.98047 5.29297C2.80468 4.36328 1.13281 5.63672 1.64062 6.99219C2.17187 6.89453 2.87109 7.15625 3.22656 7.60547C3.40234 7.79688 3.24218 8.12891 2.98828 8.12109C2.89843 8.12109 2.8125 8.08203 2.75 8.00781C2.66796 7.91016 2.48437 7.73047 2.19531 7.64844C1.99218 7.58203 1.71093 7.59766 1.54687 7.65234C-0.0742226 8.125 -0.207035 10.4297 1.33984 11.0898C1.55078 10.75 2.78515 9.80859 3.00781 10.4688C3.05078 10.6367 2.94531 10.8086 2.78125 10.8477C0.999996 11.2891 1.24609 13.7891 3.08203 13.8398C3.08593 13.5352 3.18359 13.1992 3.4375 12.9453ZM11.6523 4.45703C11.7344 4.45703 11.8125 4.42578 11.875 4.36719L13.3242 2.91797C13.6094 2.62109 13.1758 2.1875 12.8828 2.47656L11.4336 3.92578C11.2305 4.10938 11.3828 4.46484 11.6523 4.45703ZM15.4414 8.03516H13.3945C12.9805 8.04297 12.9844 8.65625 13.3945 8.66016H15.4414C15.8555 8.65625 15.8516 8.04297 15.4414 8.03516ZM11.8711 12.3359C11.5742 12.0508 11.1406 12.4844 11.4297 12.7773L12.8789 14.2266C13.1719 14.5156 13.6094 14.0742 13.3203 13.7852C13.3203 13.7812 11.8711 12.3359 11.8711 12.3359ZM7.44531 2.71484C7.61718 2.71484 7.75781 2.57422 7.75781 2.40234V0.351562C7.75781 0.179688 7.61718 0.0390625 7.44531 0.0390625C7.27343 0.0390625 7.13281 0.179688 7.13281 0.351562V2.39844C7.13281 2.57422 7.27343 2.71484 7.44531 2.71484Z" fill="#014A3F" />
						</svg>
						<span>تفکر عمیق</span>
					</button>
					<button
						type="button"
						className={`thinking-btn ${refinementMode ? 'active' : ''}`}
						onClick={() => { setAdvOptionsOpen(false); setRefinementMode(prev => !prev) }}
						title="بهبود پاسخ"
					>
						<span>بهبود پاسخ</span>
					</button> */}
					{/* {/*<button
						type="button"
						className={`thinking-btn ${askDB ? 'active' : ''}`}
						onClick={() => { setAdvOptionsOpen(false); setAskDB(prev => !prev) }}
						title="سوال از دیتابیس"
					>
						<span>سوال از دیتابیس</span>
					</button> */}
					<button
						type="button"
						id='ask-web'
						className={`thinking-btn refinement ${askWeb ? 'active' : ''}`}
						onClick={() => { setAdvOptionsOpen(false); setAskWeb(prev => !prev) }}
						title="سوال از وبسایت سازمان"
					>
						<span>سوال از وبسایت سازمان</span>
					</button>
				</div>
			</div>
			{/*  Suggestion dropdown */}
			{showSuggestions && (
				<ul
					className="suggestions-dropdown"
				>
					{suggestions.map((s, i) => (
						<li
							className='suggestion-dropdown-item'
							key={i}
							onClick={() => handleSuggestionClick(s)}
						>
							{s}
						</li>
					))}
				</ul>
			)}

			{/*  Main text area */}
			<textarea
				autoFocus
				ref={textareaRef}
				onChange={handleChange}
				placeholder="پیام..."
				value={input}
				rows="1"
				onKeyDown={(e) => {
					if (e.key === 'Enter' && !e.shiftKey) {
						e.preventDefault();
						if ( isTypingChatIndex === -1) {
							textareaRef.current.style.height = "auto";
							setIsMultiline(false);
							setShowSuggestions(false);
							handleSend();
						}						
					}
				}}
			/>

			{/* <div className='active-options'>
				<button
					type="button"
					className='thinking-btn thinking-btn-indicator'
					style={{ display: thinkingMode ? 'flex' : 'none' }}
					title="تفکر عمیق"
				>
					<svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M10.3398 16.1523C10.3398 16.3555 10.2656 16.543 10.1367 16.6836H3.23046C2.77343 16.1914 3.15234 15.332 3.83203 15.3477H9.53515C9.98046 15.3477 10.3398 15.707 10.3398 16.1523ZM3.23046 17.2266C2.77343 17.7188 3.15234 18.5781 3.83203 18.5625H9.53515C10.2148 18.5781 10.5937 17.7148 10.1328 17.2266H3.23046ZM5.5 19.9609H7.87109C8.3789 19.9609 8.79687 19.5898 8.8789 19.1055H4.49218C4.57421 19.5898 4.99218 19.9609 5.5 19.9609ZM10.6289 11.9609C9.79297 12.6875 9.28125 13.7109 9.17578 14.8047H7.44531V3.86719C7.44531 3.63672 7.64062 3.45312 7.87109 3.47266C12.1445 3.85156 13.8125 9.21484 10.6289 11.9609ZM11.3867 8.30469C11.3984 6.66406 10.3203 5.125 8.76562 4.58984C8.60547 4.53125 8.42187 4.61719 8.36718 4.78125C8.30859 4.94531 8.39062 5.12109 8.55468 5.17969C9.85937 5.62891 10.7695 6.92188 10.7578 8.30469C10.7656 8.71484 11.3828 8.71484 11.3867 8.30469ZM3.4375 12.9453C3.64062 12.7344 4.10156 12.4609 4.27343 12.8477C4.33593 13.0078 4.2539 13.1914 4.08984 13.2539C3.38671 13.5742 3.75 14.5234 4.1875 14.8047H5.58984C5.89062 14.5859 6.08593 14.2344 6.08593 13.8359V4.98047C6.07812 3.70312 4.32812 3.32812 3.80468 4.48828C4.22656 4.57031 5.47265 5.63281 4.57812 5.83203C4.28125 5.82031 4.21484 5.42578 3.98047 5.29297C2.80468 4.36328 1.13281 5.63672 1.64062 6.99219C2.17187 6.89453 2.87109 7.15625 3.22656 7.60547C3.40234 7.79688 3.24218 8.12891 2.98828 8.12109C2.89843 8.12109 2.8125 8.08203 2.75 8.00781C2.66796 7.91016 2.48437 7.73047 2.19531 7.64844C1.99218 7.58203 1.71093 7.59766 1.54687 7.65234C-0.0742226 8.125 -0.207035 10.4297 1.33984 11.0898C1.55078 10.75 2.78515 9.80859 3.00781 10.4688C3.05078 10.6367 2.94531 10.8086 2.78125 10.8477C0.999996 11.2891 1.24609 13.7891 3.08203 13.8398C3.08593 13.5352 3.18359 13.1992 3.4375 12.9453ZM11.6523 4.45703C11.7344 4.45703 11.8125 4.42578 11.875 4.36719L13.3242 2.91797C13.6094 2.62109 13.1758 2.1875 12.8828 2.47656L11.4336 3.92578C11.2305 4.10938 11.3828 4.46484 11.6523 4.45703ZM15.4414 8.03516H13.3945C12.9805 8.04297 12.9844 8.65625 13.3945 8.66016H15.4414C15.8555 8.65625 15.8516 8.04297 15.4414 8.03516ZM11.8711 12.3359C11.5742 12.0508 11.1406 12.4844 11.4297 12.7773L12.8789 14.2266C13.1719 14.5156 13.6094 14.0742 13.3203 13.7852C13.3203 13.7812 11.8711 12.3359 11.8711 12.3359ZM7.44531 2.71484C7.61718 2.71484 7.75781 2.57422 7.75781 2.40234V0.351562C7.75781 0.179688 7.61718 0.0390625 7.44531 0.0390625C7.27343 0.0390625 7.13281 0.179688 7.13281 0.351562V2.39844C7.13281 2.57422 7.27343 2.71484 7.44531 2.71484Z" fill="#014A3F" />
					</svg>
					<span>تفکر عمیق</span>
				</button>
			</div> */}

			{/* دکمه ارسال */}
			<button
				type="button"
				className="send-btn"
				disabled={isTypingChatIndex !== -1 && isTypingChatIndex !== currentChatIndex}
				onClick={() => {
					if (isTypingChatIndex === -1) {
						textareaRef.current.style.height = "auto";
						setIsMultiline(false);
						setShowSuggestions(false);
						handleSend();
					}					
				}}
				title="ارسال"
			>
				{
					isTypingChatIndex !== currentChatIndex &&
					<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="icon"><path d="M8.99992 16V6.41407L5.70696 9.70704C5.31643 10.0976 4.68342 10.0976 4.29289 9.70704C3.90237 9.31652 3.90237 8.6835 4.29289 8.29298L9.29289 3.29298L9.36907 3.22462C9.76184 2.90427 10.3408 2.92686 10.707 3.29298L15.707 8.29298L15.7753 8.36915C16.0957 8.76192 16.0731 9.34092 15.707 9.70704C15.3408 10.0732 14.7618 10.0958 14.3691 9.7754L14.2929 9.70704L10.9999 6.41407V16C10.9999 16.5523 10.5522 17 9.99992 17C9.44764 17 8.99992 16.5523 8.99992 16Z"></path></svg>
				}

				{
					isTypingChatIndex === currentChatIndex &&
					<svg width="15" height="15" xmlns="http://www.w3.org/2000/svg">
						<rect width="15" height="15" rx="2" ry="2" fill="#FEFFFD" />
					</svg>

				}

			</button>


			{/* input مخفی فایل */}
			<input
				ref={fileInputRef}
				type="file"
				accept='.pdf,.doc,.docx,.txt'
				multiple
				style={{ display: 'none' }}
				onChange={(e) => onFilesSelected(e.target.files)}
			/>
		</div>
	);
};

export default InputBox;

